var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 4.46875H12.75V3.09375C12.75 2.90469 12.5925 2.75 12.4 2.75H11.7C11.5075 2.75 11.35 2.90469 11.35 3.09375V4.46875H9.95C9.7575 4.46875 9.6 4.62344 9.6 4.8125V5.5C9.6 5.68906 9.7575 5.84375 9.95 5.84375H11.35V7.21875C11.35 7.40781 11.5075 7.5625 11.7 7.5625H12.4C12.5925 7.5625 12.75 7.40781 12.75 7.21875V5.84375H14.15C14.3425 5.84375 14.5 5.68906 14.5 5.5V4.8125C14.5 4.62344 14.3425 4.46875 14.15 4.46875ZM5.4 5.5C6.94656 5.5 8.2 4.26895 8.2 2.75C8.2 1.23105 6.94656 0 5.4 0C3.85344 0 2.6 1.23105 2.6 2.75C2.6 4.26895 3.85344 5.5 5.4 5.5ZM7.36 6.1875H6.99469C6.50906 6.40664 5.96875 6.53125 5.4 6.53125C4.83125 6.53125 4.29313 6.40664 3.80531 6.1875H3.44C1.81687 6.1875 0.5 7.48086 0.5 9.075V9.96875C0.5 10.5381 0.970313 11 1.55 11H9.25C9.82969 11 10.3 10.5381 10.3 9.96875V9.075C10.3 7.48086 8.98312 6.1875 7.36 6.1875Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsBlack);
export default __webpack_public_path__ + "static/media/contacts-black.25ca2f7040b32801ad717a2843d63f53.svg";
export { ForwardRef as ReactComponent };